import { Spin } from 'antd'
import { Moment } from 'moment'
import { useTranslation } from 'react-i18next'

import {
  ContainerTable,
  DataCellWrapper,
  EffortWrapper,
  HeaderCelDate,
  HeaderCellWrapper,
  TableCustom,
  TableWrapper,
  Wrappertable,
} from '@/components/pages/ClientDevice/styles'
import { GetClientDeviceByDayResponse } from '@/types/apis/clientDevice'
import { formatDateSendRequest, formatYMD } from '@/utils/date'

type Props = {
  responseClientDevice: GetClientDeviceByDayResponse
  responseClientDeviceLoading?: boolean
  dateFilter?: Moment | null
}

const ClientDeviceByDayTable = ({ responseClientDevice, responseClientDeviceLoading, dateFilter }: Props) => {
  const { t } = useTranslation()
  const dataSource = responseClientDevice.items

  return (
    <ContainerTable>
      <Spin spinning={responseClientDeviceLoading}>
        <TableWrapper>
          <EffortWrapper>{t('components.pages.clientDevice.listReport.table.hour')}</EffortWrapper>
          <Wrappertable>
            <TableCustom>
              <tbody>
                <tr>
                  <HeaderCelDate>{t('components.pages.clientDevice.listReport.table.date')}</HeaderCelDate>
                  {dataSource?.map((item, index) => (
                    <HeaderCellWrapper key={index}>{item.name}</HeaderCellWrapper>
                  ))}
                  <HeaderCellWrapper>{t('components.pages.clientDevice.listReport.table.total')}</HeaderCellWrapper>
                </tr>
                {dateFilter && (
                  <tr>
                    <DataCellWrapper>{formatYMD(formatDateSendRequest(dateFilter))}</DataCellWrapper>
                    {dataSource?.map((item, index) => (
                      <DataCellWrapper key={index}>
                        {item.workingTime ? item.workingTime.toFixed(1) : undefined}
                      </DataCellWrapper>
                    ))}
                    <DataCellWrapper>{responseClientDevice?.totalWorkingTime.toFixed(1)}</DataCellWrapper>
                  </tr>
                )}
              </tbody>
            </TableCustom>
          </Wrappertable>
        </TableWrapper>
      </Spin>
    </ContainerTable>
  )
}
ClientDeviceByDayTable.displayName = 'ClientDeviceByDayTable'
export default ClientDeviceByDayTable
